import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: this directory existed only to fan out internal links across
// the 2,400-page programmatic keyword matrix, which has been deleted.
// The curated hub at /calculators is the replacement.
export const Route = createFileRoute("/site-directory")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
